import React from 'react';
import { navigate } from "gatsby";
import Toolbar from '@material-ui/core/Toolbar';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import InboxIcon from '@material-ui/icons/MoveToInbox';
import MailIcon from '@material-ui/icons/Mail';
import List from '@material-ui/core/List';
import Drawer from '@material-ui/core/Drawer';
import Divider from '@material-ui/core/Divider';

import drawerStyles from "./drawerStyles";

import Hidden from '@material-ui/core/Hidden';


export default function TheDrawer(props) {
    const classes = drawerStyles();

    const { window } = props;

    const { menuState } = props;
    const handleDrawerToggle = () => {
        props.setMenuState(!menuState);
      };

    const drawer = (
        <div>
            <Toolbar />
            <div className={classes.drawerContainer}>
              <List>
                {['Summarize', 'Questions', 'Flash-cards', 'Fill-in'].map((text, index) => {
                  const slug = "/app/" + text.toLowerCase()
                  return (
                  <ListItem button key={text} onClick={()=>navigate(slug)}>
                    <ListItemIcon>{index % 2 === 0 ? <InboxIcon /> : <MailIcon />}</ListItemIcon>
                    <ListItemText primary={text} />
                  </ListItem>
                )}
                )}
                <Hidden smUp  implementation="js">
                    <Divider />
                    <ListItem button key="about" onClick={()=>navigate("/about")}>
                    <ListItemIcon> <MailIcon /></ListItemIcon>
                    <ListItemText primary="About us" />
                    </ListItem>
                </Hidden>
              </List>
            </div>
        </div>
    );
    
    const container = window !== undefined ? () => window().document.body : undefined;

    return (
        <nav className={classes.drawer} aria-label="mailbox folders">
            <Hidden xsDown implementation="js">
                <Drawer
                    className={classes.drawer}
                    variant="permanent"
                    classes={{
                        paper: classes.drawerPaper,
                    }}
                >
                    {drawer}
                </Drawer>
            </Hidden>
            <Hidden smUp implementation="js">
                <Drawer
                    container={container}
                    variant="temporary"
                    anchor="left"
                    open={menuState}
                    onClose={handleDrawerToggle}
                    classes={{
                        paper: classes.drawerPaper,
                    }}
                    ModalProps={{
                        keepMounted: true, // Better open performance on mobile.
                    }}
                >
                    {drawer}
                </Drawer>
            </Hidden>
        </nav>
    );
}
